import React from 'react';
import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';
import ShoppingsDesktop from './assets/shoppings-desktop.webp';
import ShoppingsMobile from './assets/shoppings-mobile.webp';

const Benefit = () => (
  <section className="bg-white py-8 md:py-20">
    <div className="max-w-[1300px] w-full px-5 mx-auto">
      <Title className="text-center md:text-center">Os seus shoppings de coração estão aqui</Title>
      <Subtitle className="max-w-3xl mx-auto mt-4 text-center md:text-center">
        O Multi está presente em todos os shoppings Multiplan.
        <br />A qualidade e confiança que você conhece, também no app.
      </Subtitle>

      {/* Illustrative image */}
      <div className="flex justify-center mt-12">
        <img
          src={ShoppingsDesktop}
          alt="Usuária utilizando o app Multi"
          className="max-w-full h-auto hidden md:block"
        />
        <img src={ShoppingsMobile} alt="Usuária utilizando o app Multi" className="max-w-full h-auto block md:hidden" />
      </div>
    </div>
  </section>
);

export default Benefit;
